import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import AuthShell from "./AuthShell";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function VerifyEmail() {
  const { token } = useParams();
  const [state, setState] = useState("loading"); // loading | success | error
  const [email, setEmail] = useState("");

  useEffect(() => {
    api
      .get(`/auth/verify-email/${token}`)
      .then((r) => {
        setEmail(r.data.email);
        setState("success");
      })
      .catch(() => setState("error"));
  }, [token]);

  return (
    <AuthShell title="Vérification e-mail">
      <div className="space-y-6" data-testid="verify-email-page">
        {state === "loading" && (
          <div className="flex items-center gap-3 text-zinc-600">
            <Loader2 className="animate-spin" size={18} />
            <span className="text-sm">Vérification en cours…</span>
          </div>
        )}
        {state === "success" && (
          <div className="border border-[#16A34A]/30 bg-[#16A34A]/5 p-6">
            <div className="flex items-start gap-3">
              <CheckCircle2 className="text-[#16A34A] shrink-0" size={22} strokeWidth={1.5} />
              <div>
                <div className="text-sm font-medium text-zinc-900">E-mail confirmé</div>
                <div className="mt-1 text-sm text-zinc-600">
                  L'adresse <span className="font-mono">{email}</span> est désormais vérifiée.
                </div>
              </div>
            </div>
          </div>
        )}
        {state === "error" && (
          <div className="border border-[#DC2626]/30 bg-[#DC2626]/5 p-6">
            <div className="flex items-start gap-3">
              <XCircle className="text-[#DC2626] shrink-0" size={22} strokeWidth={1.5} />
              <div>
                <div className="text-sm font-medium text-zinc-900">Lien invalide ou expiré</div>
                <div className="mt-1 text-sm text-zinc-600">
                  Essayez de vous reconnecter pour recevoir un nouveau lien.
                </div>
              </div>
            </div>
          </div>
        )}
        <Link
          to="/login"
          data-testid="verify-go-login"
          className="inline-block bg-[#002FA7] hover:bg-[#00227A] text-white text-sm font-medium px-6 py-2.5 transition-colors"
        >
          Aller à la connexion
        </Link>
      </div>
    </AuthShell>
  );
}
